import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../utils/localStorage";
import { useState } from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useEffect } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import {
  getStoreByWarehouseInfo,
  getWarehouseOrderStatusReport,
} from "../services/warehouse/WarehouseProcess";
import {
  localeDateEndDate,
  localeDateStartDate,
} from "../constants/DateUtil/DateUtil";
import SchedularModalOrderStatusReport from "../pages/SchedularModalOrderStatusReport";
import { DataTable } from "primereact/datatable";
import { Column } from "jspdf-autotable";
import { Dropdown } from "primereact/dropdown";

const { innerWidth: width, innerHeight: height } = window;

const WarehousePreviousDayDeliveryReport = () => {
  const navigate = useNavigate();

  const { warehouseData } = getUserData();

  let warehouseId = warehouseData.id;

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 7); // subtract 7 days to current date

  const [orderStatusReportData, setOrderStatusReportData] = useState([]);

  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [challanSchedularModalVisible, setChallanSchedularModalVisible] =
    useState(false);

  const [storeValue, setStoreValue] = useState("");
  const [storeList, setStoreList] = useState([]);
  const [storeListAll, setStoreListAll] = useState([]);
  const [storeListId, setStoreListId] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermView, setSearchTermView] = useState(false);

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setStartDate(newSchedular?.startDate);
    setEndDate(newSchedular?.endDate);
  };

  const initializeVariable = () => {
    setOrderStatusReportData([]);
  };

  const handleCalendarModal = () => {
    setChallanSchedularModalVisible(true);
  };

  const handleStoreChange = (selectedItem) => {
    setStoreValue(selectedItem);
    setSearchTerm("");
  };

  const fetchStoreData = () => {
    getStoreByWarehouseInfo(warehouseId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const storeData = response.data.map((item) => ({
            name: item.store.storeName,
            value: item.id, // store.id
          }));
          const storeDataId = response.data.map((item) => item.id);

          setStoreList(storeData);
          setStoreListAll(Res);
          setStoreListId(storeDataId);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreData();
  }, []);

  const fetchReport = (data) => {
    getWarehouseOrderStatusReport(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setOrderStatusReportData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    if (storeValue) {
      const filterSelectedStore = storeListAll.filter(
        (item) => item.id === storeValue,
      );
      
      const dateAddOn =
        filterSelectedStore[0]?.store?.tagDeliveryDateInterval - 1;

      const maxDate = new Date();
      maxDate.setDate(maxDate.getDate() + dateAddOn);

      const minDate = new Date();
      minDate.setDate(maxDate.getDate() - 7);

      const currentDateTimeStartDate = minDate.toISOString();
      const currentDateTimeEndDate = maxDate.toISOString();

      const data = {
        recordType: "DELIVERY_ON",
        startDate: localeDateStartDate(currentDateTimeStartDate),
        endDate: localeDateEndDate(currentDateTimeEndDate),
        wareHouseIds: [warehouseId],
        storeWareHouseIds: storeValue ? [storeValue] : storeListId,
        status: ["IN_PROCESS", "PROCESSED", "UNPROCESSED", "READY_TO_SEND_TO_STORE_BY_WARE_HOUSE"]
      };
      fetchReport(data);
    }
  }, [storeValue]);

  const filterOrderInfoList = () => {
    return orderStatusReportData.filter((item) => {
      const invoiceNo = item?.invoiceNo?.toLowerCase();
      const matchesSearchTermInvoiceNo = invoiceNo?.includes(
        searchTerm?.toLowerCase(),
      );
      return matchesSearchTermInvoiceNo;
    });
  };

  const filteredOrderInfoData = filterOrderInfoList();

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const wareHouseStatusColor = {
    IN_TIME: "#F4C430",
    OUT_TIME: "#F76AA0",
    DEFAULT: "#3EB3E1",
  };

  const itemTemplate = (order, index) => {
    const orderStatusColor = wareHouseStatusColor.DEFAULT;
    return (
      <div className="flex flex-row">
        <Accordion className="order-accordion">
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
              fontSize: 10,
            }}
            header={`${index + 1}`}
          ></AccordionTab>
        </Accordion>
        <Accordion className="order-flex-accordion">
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
              fontSize: 10,
            }}
            header={`Bill No. - ${order.invoiceNo} | Total Garment - ${order.count}`}
          >
            <div className="cursor-pointer">
              {order?.orderStatusList.map((item) => (
                <div className="flex-row">
                  <div className="col-6">
                    <p className="text-base font-semiBold capitalize">Status</p>
                    <p className="text-lg font-bold capitalize">
                      {item.status.replace(/_/g, " ")}
                    </p>
                  </div>
                  <div className="col-6">
                    <p className="text-base font-semiBold capitalize">
                      Garment Count
                    </p>
                    <p className="text-lg font-bold capitalize">{item.count}</p>
                  </div>
                </div>
              ))}
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    );
  };

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div>{list}</div>;
  };

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div className="cursor-pointer">
        <span>{rowData?.invoiceNo}</span>
      </div>
    );
  };

  const RenderTabView = (data) => {
    // Get all unique statuses from all orders
    const statusColumns = [
      ...new Set(
        data?.flatMap((item) =>
          item?.orderStatusList?.map((statusItem) => statusItem.status),
        ),
      ),
    ];

    return (
      <DataTable
        showGridlines
        value={data}
        paginator
        rows={100}
        rowsPerPageOptions={[50, 100]}
        stripedRows
        scrollable
        scrollHeight={height - 280}
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) => options.rowIndex + 1}
        />

        <Column
          field="invoiceNo"
          header="Invoice No"
          style={{
            width: "120px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={invoiceBodyTemplate}
        />

        <Column field="count" header="Total Garment" />

        {statusColumns.map((status) => (
          <Column
            key={status}
            header={status
              .replace(/_/g, " ")
              .replace("SENT TO WARE HOUSE", "RECEIVED")}
            style={{ minWidth: "180px" }}
            body={(rowData) => {
              const statusData = rowData?.orderStatusList?.find(
                (item) => item.status === status,
              );

              return <span>{statusData?.count ?? 0}</span>;
            }}
          />
        ))}
      </DataTable>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Delay Delivery Report
              </p>
            </div>
          </div>

          <i
            className="pi pi-search"
            onClick={() => setSearchTermView(!searchTermView)}
            style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
          ></i>
        </div>
      </div>

      <div className="mx-4 my-2">
        {searchTermView && (
          <div className="my-2 mx-1 flex flex-1">
            <div className="flex-1">
              <IconField iconPosition="left" className="flex flex-1">
                <InputIcon className="pi pi-search text-xl"> </InputIcon>
                <InputText
                  placeholder={"Search Invoice No."}
                  value={searchTerm}
                  keyboardType={"numeric"}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="text-xl flex flex-1 py-1 px-5"
                  style={{ borderRadius: 30 }}
                />
              </IconField>
            </div>

            {searchTerm && (
              <div
                className="flex justify-content-center align-items-center mx-2 cursor-pointer"
                onClick={handleClearSearch}
              >
                <p className="text-3xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            )}
          </div>
        )}
        <div>
          <div className="flex-1 flex flex-column justify-content-center align-items-center">
            <div className="w-full ">
              <div className="mx-2 mt-2">
                <Dropdown
                  value={storeValue}
                  onChange={(e) => handleStoreChange(e.value)}
                  options={storeList}
                  placeholder="Select Store"
                  optionLabel="name"
                  className="w-full  bg-white-alpha-20 border-round-xl text-2xl text-primary-50"
                />
              </div>
            </div>
          </div>
          {orderStatusReportData.length > 0 ? (
            <>
              <div className="scroll-bar mb-2 mt-4">
                <div className="mx-4 report-table">
                  <div className="tab-view-table">
                    {RenderTabView(
                      filteredOrderInfoData || orderStatusReportData,
                    )}
                  </div>
                </div>
              </div>
              {/* <DataView
                value={filteredOrderInfoData || orderStatusReportData}
                listTemplate={listTemplate}
                paginator
                rows={20}
              /> */}
            </>
          ) : orderStatusReportData.length === 0 ? (
            <div className="flex-1 flex flex-column justify-content-center align-items-center">
              <p className="text-3xl font-Bold">No Tag Found</p>
            </div>
          ) : (
            <div className="flex-1 flex flex-column justify-content-center align-items-center">
              <p className="text-3xl font-Bold">Tag List is Loading</p>
            </div>
          )}
        </div>

        <SchedularModalOrderStatusReport
          setSchedularModalVisible={setChallanSchedularModalVisible}
          schedularModalVisible={challanSchedularModalVisible}
          sendDataToOrdersPage={receiveDataFromSchedularModal}
          typeOfOrder={""}
        />
      </div>
    </div>
  );
};

export default WarehousePreviousDayDeliveryReport;
